<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/investor-relations/shareholder-information/ir-contact',
    'fr-CA': '/relations-avec-investisseurs/section-investisseurs/information-aux-investisseurs'
  }
})

useHead({
  title: t('navigation.irContact.metatitle'),
  meta: [{ name: 'description', content: t('navigation.irContact.metadescription') }]
})

</script>
<template>
   <div class="wrapContent">
      <div class="entetePage">
         <div class="wrapper">
            <div class="filAriane">
               <span class="">
                  <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
                  <span class=""> &gt; </span>
                  <NuxtLink :to="localePath('investorRelations-investorRelations')">{{ $t('navigation.investorRelations.name') }}</NuxtLink>
                  <span class=""> &gt; </span>
                  <NuxtLink :to="localePath('investorRelations-shareholderInformation')">{{ $t('navigation.shareholderInformation.name') }}</NuxtLink>
                  <span class=""> &gt; </span>
                  <span class="">{{ $t('navigation.irContact.name') }}</span>
               </span>
            </div>
            <div class="title">
               <h1><span class="">{{ $t('navigation.irContact.name') }}</span></h1>
            </div>
         </div>
      </div>
      <div class="contentPage">
         <div class="wrapper clearfix">
            <MenuInvestorRelations />
            <div class="contenu right">
               <div v-if="$i18n.locale == 'en-CA'"
                  class="">
                  <h2>Corporate address</h2>
                  <p>
                    2 Prologis Blvd., Suite 500<br>Mississauga, Ontario<br>L5W 0G8<br>Telephone:
                    <a class="tel"
                     name="hyperlien"
                     href="tel:1-905-812-6900"
                     target="_blank">905-812-6900</a>
</p>
                  <h2>Investor relations</h2>
                  <p>
                     Doris Grbic<br>Director, Investor Relations<br>Telephone: <a class="tel"
                        name="hyperlien"
                        href="tel:1-437-882-2596"
                        target="_blank">437-882-2596</a><br>
                        <a href="mailto:IR@krugerproducts.ca">IR@krugerproducts.ca</a>
                  </p>
               </div>
               <div v-if="$i18n.locale == 'fr-CA'"
                  class="">
                  <h2>Adresse de la société</h2>
                  <p>
                     2 boul. Prologis, bureau 500<br>Mississauga (Ontario) L5W 0G8<br>Téléphone : <a href="tel:1-905-812-6900">905 812-6900</a>
                  </p>
                  <h2>Relations avec les investisseurs</h2>
                  <p>
Doris Grbic<br>Directrice, Relations avec les investisseurs<br>Téléphone : <a href="tel:1-437-882-2596">437-882-2596</a><br>
                  <a href="mailto:IR@krugerproducts.ca">IR@krugerproducts.ca</a>
</p>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<style lang="scss"></style>
